import React from 'react';
import ReactMarkdown from 'react-markdown'; // この行を追加

const AIAssistant = ({ suggestion, hasError, isLoading }) => {
  return (
    <div className="assistant-panel">
      <div className="assistant-header">
        <svg className="assistant-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
        <h3>AIアシスタント</h3>
        {isLoading ? (
          <span className="loading-badge">分析中...</span>
        ) : hasError ? (
          <span className="error-badge">エラー検出</span>
        ) : (
          <span className="success-badge">正常</span>
        )}
      </div>
      <div className="assistant-content">
        {isLoading ? (
          <div className="loading-indicator">
            <p>AIが分析しています...</p>
          </div>
        ) : (
          <ReactMarkdown>{suggestion}</ReactMarkdown>
        )}
      </div>
    </div>
  );
};

export default AIAssistant; // この行も確認